module.exports = __webpack_public_path__ + "img/ico_external.04015582.svg";